import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ResolvedEmailsPage } from '@features/admin/resolved-emails';
import { useAdminResolvedEmailStore } from '@features/admin/resolved-emails/useAdminResolvedEmailStore.ts';

const adminResolvedEmailsSearchSchema = z.object({
  search: z.string().optional(),
  // RATE_LIMITED chybelo, presto ho filtr nabizi — vyber toho stavu shodil parsovani URL.
  status: z.enum(['PENDING', 'SCHEDULED', 'SENDING', 'SENT', 'FAILED', 'SKIPPED', 'RATE_LIMITED']).optional(),
  // Skutecne doruceni (z Mailgun Events API), na rozdil od `status` = jen predano Mailgunu.
  deliveryStatus: z.enum(['UNKNOWN', 'DELIVERED', 'INVALID_ADDRESS', 'FAILED_TEMPORARY', 'FAILED_PERMANENT', 'BLOCKED_TEMPORARILY', 'REJECTED', 'GIVEN_UP']).optional(),
  // Pozor: ne z.coerce.boolean() — Boolean('false') je true, takže by filtr z URL nešel vypnout.
  undeliveredOnly: z
    .boolean()
    .or(z.enum(['true', 'false']).transform(v => v === 'true'))
    .optional(),
  organizationId: z.coerce.number().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AdminResolvedEmailsSearch = z.infer<typeof adminResolvedEmailsSearchSchema>;

export const Route = createFileRoute('/admin/resolved-emails/')({
  validateSearch: search => adminResolvedEmailsSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { search, status, deliveryStatus, undeliveredOnly, organizationId, page, size } = ctx.search;
    useAdminResolvedEmailStore.getState().loadResolvedEmails({
      search,
      status,
      deliveryStatus,
      undeliveredOnly,
      organizationId,
      page: page || 1,
      size: size || 20,
    });
  },
});

function RouteComponent() {
  return <ResolvedEmailsPage />;
}
